import { render, staticRenderFns } from "./FinalFeedback.vue?vue&type=template&id=bcbd9bf8"
import script from "./FinalFeedback.vue?vue&type=script&lang=js"
export * from "./FinalFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports